//import interact from 'interactjs';

export default  {
    data: function () {
        return {
            //
        }
    },
    methods: {
        getMountedFunctions: function(obj) {
            let props = [];

            do {
                props = props.concat(Object.getOwnPropertyNames(obj));
            } while (obj = Object.getPrototypeOf(obj));

            return props.sort().filter(function (e, i, arr) {
                return (e.startsWith('mounted'));
            });
        },
        hasMinWidth: function () {
            return Math.max(1, 1 * this.frame.ratio);
        },
        hasMinHeight: function () {
            return Math.max(1, 1 * this.frame.ratio);
        }
    },
    mounted() {
        _.forEach(this.getMountedFunctions(this), (value) => {
            this[value]();
        });

        EaseEventBus.listen('element.' + this.index + '.lock', (locked) => {
            this.mountedIsResizable(locked);
        });
    }
}
